import { MonoTypeOperatorFunction, retry, throwError, timer } from 'rxjs';
export const retryStrategy = <T>(maxRetries = 3): MonoTypeOperatorFunction<T> => {
  return retry({
    count: maxRetries,
    delay: (error: any, retryCount) => {
      if (error?.status >= 500 && error.status < 600) {
        return timer(100 * retryCount);
      }
      return throwError(() => error);
    },
  });
};
